// extracted by mini-css-extract-plugin
export default {"card":"e5-z"};